import React from 'react';
import PropTypes from 'prop-types';

const Whatsapp = ({ color = '#00D95F', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none" {...props}>
    <path
      fill={color}
      d="m0 30.516 2.152-7.996A14.776 14.776 0 0 1 .6 12.283a14.805 14.805 0 0 1 5.55-8.75 14.873 14.873 0 0 1 19.41 1.253 14.782 14.782 0 0 1 1.508 19.343 14.85 14.85 0 0 1-8.7 5.649A14.88 14.88 0 0 1 8.084 28.36L0 30.516Zm8.474-5.147.5.295a12.025 12.025 0 0 0 14.533-1.763 11.944 11.944 0 0 0 2.007-14.465 11.99 11.99 0 0 0-5.792-5.11 12.028 12.028 0 0 0-7.715-.524A12.001 12.001 0 0 0 5.574 8.08a11.95 11.95 0 0 0-2.48 7.305 11.811 11.811 0 0 0 1.753 6.204l.314.516-1.204 4.463 4.517-1.2Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M20.609 17.44a2.476 2.476 0 0 0-2.119-.483c-.55.229-.907 1.09-1.263 1.522a.525.525 0 0 1-.678.152 9.594 9.594 0 0 1-4.796-4.1.574.574 0 0 1 .076-.794c.397-.392.689-.877.848-1.412a3.07 3.07 0 0 0-.39-1.69 3.954 3.954 0 0 0-1.229-1.851 1.699 1.699 0 0 0-1.822.279A3.737 3.737 0 0 0 7.94 12.02c.001.314.04.626.118.93.197.73.5 1.428.899 2.07.287.493.601.97.94 1.43a14.434 14.434 0 0 0 4.076 3.77c.798.498 1.651.904 2.543 1.208.925.418 1.947.579 2.957.465a3.554 3.554 0 0 0 2.678-1.987c.146-.317.19-.67.127-1.014-.152-.701-1.093-1.116-1.67-1.454Z"
      clipRule="evenodd"
    />
  </svg>
);

Whatsapp.propTypes = {
  color: PropTypes.string
};

export default Whatsapp;
